import React from 'react';
import './ListOrdinary.css';
import iconImage from '../../../assets/item-icon.png';

const ListOrdinary = ({items}) => {
    return (
        <ul className={"ListOrdinary"}>
            {
                items.map((item, index) => (
                    <div className={"listOrdinary__item"} key={index}>
                        <img src={iconImage} alt={item.title} />
                        <li dangerouslySetInnerHTML={{__html: item.replace(/&nbsp;/g, ' ')}}></li>
                    </div>
                ))
            }
        </ul>
    );
};

export default ListOrdinary;
